import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { callAPI } from 'utils/API';
import { AppContext } from 'contexts/AppContext';
import CircularIndeterminate from 'components/blocks/progressBar/progressBar';
import NoAccess from 'components/elements/NoAccess';
import { getOrInitMsalInstance, IS_ACTIVE_IMPERSONATION, setIsImpersonating } from 'utils/msalInstance';
import { getMsalScopes } from 'utils/msalAuthConfig';

const SSO = (props) => {
    const location = useLocation();
    const { setUserData, brandData } = useContext(AppContext);
    const token = location.search ? new URLSearchParams(location.search).get('token') : null
    const [user, setUser] = useState(null)
    const [redirectLogin, setRedirectLogin] = useState(false) 
    const [loginError, setLoginError] = useState(false);   

    const validateSession = async (idToken) => {
        try {
            const sessionResponse = await callAPI(`/sessions/validate`, 'POST', {
                body: {
                    token: token, 
                    idToken,
                    deviceTimezone: Date().toString().match(/\((.*)\)/).pop(),
                    deviceLanguage: window.navigator.language,
                }
            });

            if (sessionResponse?.accessToken) {
                localStorage.setItem('accessToken', sessionResponse.accessToken);
                setUserData(sessionResponse.user);
                setUser(sessionResponse.user);
            } else {
                setUserData(null);
                setLoginError(true);
            }
        } catch (error) {
            console.error('Session validation failed:', error);
            setLoginError(true);
        }
    }

    useEffect(() => {
        const handleMSALAuth = async () => {
            try {
                const impersonation = props.impersonation
                if (impersonation) {
                    localStorage.setItem(IS_ACTIVE_IMPERSONATION, 1);
                    setIsImpersonating(true)
                } else {
                    localStorage.removeItem(IS_ACTIVE_IMPERSONATION);
                    setIsImpersonating(false)
                }

                const msalInstance = await getOrInitMsalInstance(brandData.brandSlug, impersonation)
                const loginResponse = await msalInstance.handleRedirectPromise();
                if (loginResponse?.idToken) {
                    msalInstance.setActiveAccount(loginResponse.account)
                    validateSession(loginResponse);
                } else {
                    msalInstance.loginRedirect({
                        scopes: getMsalScopes(brandData.brandSlug),
                    });
                }
            } catch (error) {
                console.error('MSAL login failed:', error);
                setLoginError(true);
            }
        }
        
        if (brandData?.features?.enableMsalAuth){
            handleMSALAuth();
        } else {
            setRedirectLogin(true);
        }
    }, [props.impersonation]);

    return loginError ? (
        <NoAccess /> 
    ) : redirectLogin ? (
        <Navigate to={'/login'} replace={true} />
    ) : user && user.UserID ? (
        <Navigate to={'/'} replace={true} />
    ) : (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '3rem' }}>
            <CircularIndeterminate size={100} />
        </div>
    )
}

export default SSO;